/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonArticleTypeInfo,
    JsonArticleTypeInfoFromJSON,
    JsonArticleTypeInfoFromJSONTyped,
    JsonArticleTypeInfoToJSON,
} from './JsonArticleTypeInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonArticleTypeInfo
 */
export interface ApiResultOfJsonArticleTypeInfo {
    /**
     * 
     * @type {JsonArticleTypeInfo}
     * @memberof ApiResultOfJsonArticleTypeInfo
     */
    data?: JsonArticleTypeInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleTypeInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonArticleTypeInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleTypeInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleTypeInfo
     */
    result?: ApiResultOfJsonArticleTypeInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonArticleTypeInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonArticleTypeInfoFromJSON(json: any): ApiResultOfJsonArticleTypeInfo {
    return ApiResultOfJsonArticleTypeInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonArticleTypeInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonArticleTypeInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonArticleTypeInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonArticleTypeInfoToJSON(value?: ApiResultOfJsonArticleTypeInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonArticleTypeInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

